/* Custom GA4 Events */
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments)};

try {
	const customerId = ShopifyAnalytics.meta.page.customerId || null;
	if (customerId) {
		window.dataLayer.push({
			'user_id': `${customerId}`
		});
		gtag('set', 'user_id', `${customerId}`);
	}
} catch (err) {
	console.warn('Error with custom GA4: ', err);
}